import {
  SET_REPORTS_HISTORY,
  CLEAR_REPORTS_HISTORY,
  SET_HISTORY_REPORT_READY,
  SET_HISTORY_REPORT_NOT_READY
} from './../actions/reportsHistoryActions'

const initialState = {
  data: [],
  isReady: false
}

const reportsHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REPORTS_HISTORY:
      return Object.assign(
        {},
        state,
        {
          data: action.data
        }
      )
    case CLEAR_REPORTS_HISTORY:
      return Object.assign(
        {},
        state,
        initialState
      )
    case SET_HISTORY_REPORT_READY:
      return Object.assign(
        {},
        state,
        {
          isReady: true
        }
      )
    case SET_HISTORY_REPORT_NOT_READY:
      return Object.assign(
        {},
        state,
        {
          isReady: false
        }
      )
    default:
      return state
  }
}

export default reportsHistoryReducer